// constで定義した値に対応する文字列を取り出す関数

import {
  ORDER_CATEGORY_OUTSOURCING,
  ORDER_CATEGORY_PRODUCT,
  SITE_PROCESS_STATUS_COMPLETED,
  SITE_PROCESS_STATUS_IN_PROGRESS,
  SITE_PROCESS_STATUS_NOT_STARTED,
  SITE_PROCESS_STATUS_UNNECESSARY
} from '../const/Const';
import { SITE_TASK_STATUS, SEARCH_STATUS } from '../const/TaskConst';

// 工程のステータス
export const getSiteProcessStatusName = (statusId?: number | null) => {
  switch (statusId) {
    case SITE_PROCESS_STATUS_NOT_STARTED:
      return '未着手';
    case SITE_PROCESS_STATUS_IN_PROGRESS:
      return '着手中';
    case SITE_PROCESS_STATUS_COMPLETED:
      return '完了';
    case SITE_PROCESS_STATUS_UNNECESSARY:
      return '実施不要';
    default:
      return undefined;
  }
};

// タスクのステータス
export const getSiteTaskStatusName = (statusId?: number | null) => {
  switch (statusId) {
    case SITE_TASK_STATUS.NOT_STARTED.value:
      return SITE_TASK_STATUS.NOT_STARTED.label;
    case SITE_TASK_STATUS.IN_PROGRESS.value:
      return SITE_TASK_STATUS.IN_PROGRESS.label;
    case SITE_TASK_STATUS.COMPLETED.value:
      return SITE_TASK_STATUS.COMPLETED.label;
    case SITE_TASK_STATUS.UNNECESSARY.value:
      return SITE_TASK_STATUS.UNNECESSARY.label;
    default:
      return undefined;
  }
};

// タスク管理の検索ステータス
export const getSiteTaskSearchStatusName = (statusId?: number | null) => {
  switch (statusId) {
    case SEARCH_STATUS.ALL.value:
      return SEARCH_STATUS.ALL.label;
    case SEARCH_STATUS.NOT_STARTED.value:
      return SEARCH_STATUS.NOT_STARTED.label;
    case SEARCH_STATUS.IN_PROGRESS.value:
      return SEARCH_STATUS.IN_PROGRESS.label;
    case SEARCH_STATUS.COMPLETED.value:
      return SEARCH_STATUS.COMPLETED.label;
    case SEARCH_STATUS.UNNECESSARY.value:
      return SEARCH_STATUS.UNNECESSARY.label;
    case SEARCH_STATUS.ALERT_ONLY.value:
      return SEARCH_STATUS.ALERT_ONLY.label;
    default:
      return undefined;
  }
};

// OrderCategory
export const getOrderCategoryName = (categoryId: number | null) => {
  switch (categoryId) {
    case ORDER_CATEGORY_OUTSOURCING:
      return '外注';
    case ORDER_CATEGORY_PRODUCT:
      return '商品';
    default:
      return undefined;
  }
};
